module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Strike-Back-S7.cc82181.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Strike-Back-S7.jpg
// module id = /8GZ
// module chunks = 0